import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { JssModule } from '@sitecore-jss/sitecore-jss-angular';
import { MatLegacyMenuModule } from '@angular/material/legacy-menu';
import { MatLegacyTooltipModule } from '@angular/material/legacy-tooltip';

import { SharedModule } from './../shared/shared.module';
import { AccountsOverviewComponent } from './components/accounts-overview/accounts-overview.component';
import { RouterModule } from '@angular/router';
import { BankAccountSettingsComponent } from './components/bank-account-settings/bank-account-settings.component';
import { AccountManagerInformationComponent } from './components/account-manager-information/account-manager-information.component';

const DashboardComponents = [
  {
    name: 'AccountManagerInformation',
    type: AccountManagerInformationComponent
  },
  { name: 'AccountsOverview', type: AccountsOverviewComponent },
  { name: 'BankAccountSettings', type: BankAccountSettingsComponent }
];

@NgModule({
  declarations: [
    AccountsOverviewComponent,
    BankAccountSettingsComponent,
    AccountManagerInformationComponent
  ],
  imports: [
    SharedModule,
    CommonModule,
    JssModule,
    RouterModule,
    MatLegacyMenuModule,
    MatLegacyTooltipModule
  ]
})
export class DashboardModule {}

export { DashboardComponents };
